import { CODES_ROUTES, DASHBOARD_ROUTES } from "shared/config/routes";

export const CODES_NAV_ROUTES = [
  DASHBOARD_ROUTES.CODES,
  CODES_ROUTES.UPLOAD_HISTORY,
  CODES_ROUTES.ERROR_CODES,
]